<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [position]="{ of: '#feeseditor' }" [(visible)]="isLoading"
  [showIndicator]="true" [showPane]="true" [shading]="true" [hideOnOutsideClick]="false" data-cy="fee-schedule-edit-load-panel">
</dx-load-panel>


<div class="main-container" *ngIf="feeSchedule" id="feeseditor" data-cy="fee-schedule-edit-container">

  <div style="margin-top: 0;" class="configuration-section-title" data-cy="fee-schedule-edit-title">Edit Fees for.: {{ feeSchedule?.FeeScheduleName }} -
    {{ feeScheduleDoctor?.Description }}</div>

  <div class="button-container" data-cy="fee-schedule-edit-button-container">

    <dx-button style="margin-right: 4px;" class="button-container-child" icon="money" type="default"
      text="Adjust Prices" (onClick)="onPriceAjustClick()" data-cy="fee-schedule-edit-adjust-button"> </dx-button>
    <dx-button style="margin-right: 4px;" class="button-container-child" icon="exportxlsx" type="default" text="Import"
      (onClick)="onImportClick()" data-cy="fee-schedule-edit-import-button"> </dx-button>

    <dx-button style="margin-right: 4px;" class="button-container-child" icon="folder" type="default"
      text="Add New Code" (onClick)="onNewCodeClick()" data-cy="fee-schedule-edit-new-code-button"> </dx-button>


    <dx-button-group class="button-container-child" [items]="feeViews" keyExpr="name" stylingMode="outlined"
      [selectedItemKeys]="[currentFeeView]" (onItemClick)="onFeeViewItemClick($event)" data-cy="fee-schedule-edit-view-buttons">
    </dx-button-group>


  </div>

  <div *ngIf="currentFeeView==='grid'" data-cy="fee-schedule-edit-grid-view">
    <dx-data-grid id="gridContainer" [dataSource]="listOfFees_Table" [showBorders]="false" [height]="900"
      keyExpr="DocFeeScheduleItemID" (onFocusedCellChanging)="onFocusedCellChangingOnTable($event)"
      (onSaving)="onSavingOnTable('grid',$event)" (onInitNewRow)="onRowInsertedOnTable($event)"
      (onEditorPreparing)="overrideOnValueChangedTable($event)" data-cy="fee-schedule-edit-grid">
      <dxo-keyboard-navigation [editOnKeyPress]="editOnkeyPress" [enterKeyAction]="enterKeyAction"
        [enterKeyDirection]="enterKeyDirection" data-cy="fee-schedule-edit-grid-keyboard"></dxo-keyboard-navigation>
      <dxo-search-panel [visible]="true" data-cy="fee-schedule-edit-grid-search"></dxo-search-panel>

      <dxo-paging [enabled]="false" data-cy="fee-schedule-edit-grid-paging"></dxo-paging>
      <dxo-editing mode="batch" [allowUpdating]="true" [startEditAction]="startEditAction"
        [selectTextOnEditStart]="true" [allowAdding]="true" [allowDeleting]="true" data-cy="fee-schedule-edit-grid-editing">
      </dxo-editing>

      <dxo-selection mode="single" data-cy="fee-schedule-edit-grid-selection"></dxo-selection>

      <dxo-filter-row [visible]=true [applyFilter]=true data-cy="fee-schedule-edit-grid-filter"></dxo-filter-row>
      <dxo-header-filter [visible]="true" data-cy="fee-schedule-edit-grid-header-filter"></dxo-header-filter>
      <dxo-search-panel [visible]="true" [width]="240" placeholder="Search..." data-cy="fee-schedule-edit-grid-search-panel"></dxo-search-panel>

      <dxi-column dataField="Code" caption="Code" [width]="100" data-cy="fee-schedule-edit-grid-code-column"></dxi-column>
      <dxi-column dataField="Description" caption="Description" [width]="600" data-cy="fee-schedule-edit-grid-description-column"></dxi-column>
      <dxi-column dataField="enumFeeItemCategoryId" caption="Category" [width]="160" data-cy="fee-schedule-edit-grid-category-column">
        <dxo-lookup [dataSource]="enumfeeItemCategories" displayExpr="ItemDisplayValue" valueExpr="ValidValueItemId" data-cy="fee-schedule-edit-grid-category-lookup">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="Fee" [width]="150" data-cy="fee-schedule-edit-grid-fee-column">
        <dxo-format type="currency" [precision]="2" data-cy="fee-schedule-edit-grid-fee-format"></dxo-format>
      </dxi-column>

    </dx-data-grid>
  </div>
  <div *ngIf="currentFeeView==='tree'" data-cy="fee-schedule-edit-tree-view">

    <div data-cy="fee-schedule-edit-tree-list-container">
      <dx-tree-list [dataSource]="listOfFees_Hierarchal" itemsExpr="FeeScheduleItems" dataStructure="tree"
        [columnAutoWidth]="true" [wordWrapEnabled]="true" [showBorders]="true" [height]="400"
        [keyExpr]="DocFeeScheduleItemID" (onSelectionChanged)="onSelectionChangedTree($event)" data-cy="fee-schedule-edit-tree-list">
        
        <dxo-selection mode="single" data-cy="fee-schedule-edit-tree-selection"></dxo-selection>

        <dxi-column dataField="Description" [minWidth]="250" data-cy="fee-schedule-edit-tree-description-column"></dxi-column>

      </dx-tree-list>
    </div>

    <div style="position: relative;" data-cy="fee-schedule-edit-tree-grid-container">


      <dx-data-grid id="gridContainerTree" [dataSource]="listOfFees_TableTreeFiltered" [showBorders]="false"
        [height]="440" keyExpr="DocFeeScheduleItemID" (onFocusedCellChanging)="onFocusedCellChangingOnTable($event)"
        (onSaving)="onSavingOnTable('tree',$event)" (onInitNewRow)="onRowInsertedOnTreeTable($event)"
        (onEditorPreparing)="overrideOnValueChangedTable($event)" data-cy="fee-schedule-edit-tree-grid">


        <dxo-filter-row [visible]=true [applyFilter]=true data-cy="fee-schedule-edit-tree-grid-filter">
        </dxo-filter-row>
        <dxo-keyboard-navigation [editOnKeyPress]="editOnkeyPress" [enterKeyAction]="enterKeyAction"
          [enterKeyDirection]="enterKeyDirection" data-cy="fee-schedule-edit-tree-grid-keyboard"></dxo-keyboard-navigation>
        <dxo-search-panel [visible]="true" data-cy="fee-schedule-edit-tree-grid-search"></dxo-search-panel>

        <dxo-paging [enabled]="false" data-cy="fee-schedule-edit-tree-grid-paging"></dxo-paging>
        <dxo-editing mode="batch" [allowUpdating]="true" [startEditAction]="click" [selectTextOnEditStart]="true"
          [allowAdding]="true" [allowDeleting]="true" data-cy="fee-schedule-edit-tree-grid-editing">
        </dxo-editing>

        <dxo-selection mode="single" data-cy="fee-schedule-edit-tree-grid-selection"></dxo-selection>

        <dxi-column dataField="ParentFeeScheduleItemID" caption="ParentFeeScheduleItemID" [width]="100"
          [visible]="false" [allowFiltering]="true" data-cy="fee-schedule-edit-tree-grid-parent-column"></dxi-column>
        <dxi-column dataField="Code" caption="Code" [width]="100" data-cy="fee-schedule-edit-tree-grid-code-column"></dxi-column>
        <dxi-column dataField="Description" caption="Description" [width]="600" data-cy="fee-schedule-edit-tree-grid-description-column"></dxi-column>
        <dxi-column dataField="enumFeeItemCategoryId" caption="Category" [width]="160" data-cy="fee-schedule-edit-tree-grid-category-column">
          <dxo-lookup [dataSource]="enumfeeItemCategories" displayExpr="ItemDisplayValue" valueExpr="ValidValueItemId" data-cy="fee-schedule-edit-tree-grid-category-lookup">

          </dxo-lookup>
        </dxi-column>
        <dxi-column dataField="Fee" [width]="150" data-cy="fee-schedule-edit-tree-grid-fee-column">
          <dxo-format type="currency" [precision]="2" data-cy="fee-schedule-edit-tree-grid-fee-format"></dxo-format>
        </dxi-column>
      </dx-data-grid>

      <div style="top: 20px; left: 10px; position: absolute;" data-cy="fee-schedule-edit-tree-grid-title">
        <b>{{treeGridTitle}}</b>
      </div>
    </div>
  </div>
</div>